import React from "react";
import { FormattedMessage } from "react-intl";

import { removeSpecialCharactersFromString } from "../MainScreen/ExportMenu";

import inputElementStyles from "./../styles/InputElements.module.css";
import styles from "./ExportName.module.css";

interface Props {
  exportName: string;
  maxExportNameLength: number;
  setExportName: (value: string) => void;
}

const ExportName: React.FC<Props> = (props) => {
  const { exportName, maxExportNameLength, setExportName } = props;

  return (
    <>
      <div>
        <FormattedMessage
          id="export_name_modal.content_text"
          defaultMessage="Almost done! Please give a unique name for exporting to Lizard. A default name with current timestamp is created for you to make sure the name is unique."
        />
      </div>
      <div className={styles.InputWrapper}>
        <div className={styles.Input}>
          <input
            maxLength={maxExportNameLength}
            className={`${inputElementStyles.Padding} ${inputElementStyles.Input}`}
            type="text"
            placeholder={"Export name must be unique"}
            value={exportName}
            onChange={(e) => {
              const nameWithoutSpecialCharacters = removeSpecialCharactersFromString(
                e.target.value
              );
              setExportName(nameWithoutSpecialCharacters);
            }}
            autoFocus
          />
          <span className={inputElementStyles.InputClearance} onClick={() => setExportName("")}>
            &#10007;
          </span>
        </div>
      </div>
    </>
  );
};

export default ExportName;
